import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "isCustomer", "onClick"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ReportButton(_ref) {
  let {
      className,
      isCustomer,
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: isCustomer,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-reviews.actions.loginRequired"
    }),
    children: /*#__PURE__*/_jsx(UIButton, Object.assign({}, rest, {
      className: className,
      disabled: !isCustomer,
      onClick: onClick,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-reviews.actions.report"
      })
    }))
  });
}